/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function brands(instance) {
	return {
		/**
		 * @param {number} brandId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (brandId, config = {}) => {
			return instance.get(`brands/${brandId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`brands${params}`, config)
		},

		/**
		 * @param {number} brandId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (brandId, body, config = {}) => {
			return instance.put(`brands/${brandId}`, body, config)
		},

		/**
		 * @param {number} brandId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (brandId, config = {}) => {
			return instance.delete(`brands/${brandId}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('brands', body, config)
		}
	}
}
